export default __webpack_public_path__ + "static/logo-final-e146ef4421d0c3dbd1e3a6337ba86a51.ico";